<template>
  <b-modal ok-variant="danger"
           ref="modal"
           :cancel-title="defaultCancelTitle"
           :ok-title="defaultOkTitle"
           :title="title"
           @ok="confirm()">
    <span v-html="message" />
  </b-modal>
</template>

<script>
export default {
  name: 'CallbackModal',

  props: {
    // Content
    message:     { type: String, required: true },
    title:       { type: String, required: true },

    // Footer
    cancelTitle: { type: String, default: this.defaultCancelTitle },
    okTitle:     { type: String, default: this.defaultOkTitle },
  },

  data: () => ({
    callback: null,
  }),

  computed: {
    defaultCancelTitle () {
      return this.$i18n.t('no');
    },

    defaultOkTitle () {
      return this.$i18n.t('yes');
    },
  },

  methods: {
    confirm () {
      if (this.callback) {
        return this.callback();
      }
    },

    hide () {
      this.$refs.modal.hide();
    },

    show (callback) {
      this.callback = callback;
      this.$refs.modal.show();
    },
  },
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/CallbackModal.vue